import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {Provider} from "react-redux";
import store from "./Redux/configStore";
import { HomeRefreshProvider } from './context/HomeRefreshContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename="/">
        <Provider store={store}>
            <HomeRefreshProvider>
                <App/>
            </HomeRefreshProvider>
        </Provider>
    </BrowserRouter>
);
